import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function SubjectTag({ subject }: { subject: string }) {
    var bordercolor = "border-blue-700";
    var textcolor = "text-white";
    var colorBackground = "bg-blue-500";

    switch (subject.toLowerCase()) {
        case "math std":
        case "maths adv":
        case "maths ext1":
        case "maths ext2":
            bordercolor = "border-sky-700";
            colorBackground = "bg-sky-500";
            //textcolor = "text-sky-300";
            break;
        case "english adv":
        case "english std":
            bordercolor = "border-rose-700";
            colorBackground = "bg-rose-500";
            //textcolor = "text-rose-300";
            break;
        case "biology":
            bordercolor = "border-teal-700";
            colorBackground = "bg-teal-500";
            //textcolor = "text-teal-300";
            break;
        case "physics":
            bordercolor = "border-purple-700";
            colorBackground = "bg-purple-500";
            //textcolor = "text-purple-300";
            break;
        case "history":
        case "geography":
            bordercolor = "border-rose-500";
            colorBackground = "bg-rose-300";
            //textcolor = "text-rose-100";
            break;
        default:
            break;
    }
    //var className = "flex flex-row rounded-lg bg-"+color+"-"+colorBackground+" border-solid border-2 border-" + color + "-" + colorBorder;
    var className = "flex flex-row mb-1 rounded-lg border-solid border " + colorBackground + " " + bordercolor + " text-xs py-1 px-3 " + textcolor;
    return (
        <div className={className} >
            <div className="grow"> {subject}</div>
            <div className="p-0 mr-2"><FontAwesomeIcon icon={faCheck} title="Mark" color="#fffffff" /> </div>
            <div className="p-0 mr-0"> # </div>
        </div>
    );
}